export enum FRONT_URLS {
  MAINTENANCE = 'maintenance',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  BAN = 'ban',
  LOGIN = 'login',
  CHECK_TOKEN = 'check-token',
  COMPLETE_REGISTRATION = 'complete-registration',
  ENTRANCE = 'entrance',
  ORG_SETTINGS = 'organization-settings',
  CABINET = 'cabinet',
  INVESTOR_ONBOARDING = 'investor-onboarding'
};

export enum MODELS_URLS {
  BASE = 'models',
  FUND_BUDGET = 'fund-budget',
  INVESTMENT = 'investment',
}
